export default [
  {
    path: '/reports',
    name: 'Reports',
    meta: { title: 'Reports', authRequired: true },
    component: () => import('../views/reports/index.vue'),
  },
  {
    path: '/reports/cargo-sales',
    name: 'CargoSalesReport',
    meta: { title: 'Cargo Sales Report', authRequired: true },
    component: () => import('../views/reports/ea/cargo-sales.vue'),
  },
  {
    path: '/reports/cargo-sales-internal',
    name: 'CargoSalesReportInternal',
    meta: { title: 'Cargo Sales Report (Internal)', authRequired: true },
    component: () => import('../views/reports/ea/cargo-sales-internal.vue'),
  },
  {
    path: '/reports/daily-tally-sheet',
    name: 'DailyTallySheet',
    meta: { title: 'Daily Tally Sheet', authRequired: true },
    component: () => import('../views/reports/ea/daily-tally-sheet.vue'),
  },
  {
    path: '/reports/ea-mawb-monthly-production',
    name: 'EaMawbMonthlyProduction',
    meta: { title: 'EA MAWB Monthly Production Per Airline', authRequired: true },
    component: () => import('../views/reports/ea/mawb-monthly-production.vue'),
  },
  {
    path: '/reports/ea-mawb-monthly-destination',
    name: 'EaMawbMonthlyDestination',
    meta: { title: 'EA MAWB Monthly Production Per Destination', authRequired: true },
    component: () => import('../views/reports/ea/mawb-monthly-destination.vue'),
  },
  {
    path: '/reports/ea-production',
    name: 'EaProduction',
    meta: { title: 'EA Production Report', authRequired: true },
    component: () => import('../views/reports/ea/production.vue'),
  },
  {
    path: '/reports/ea-booking-sheet',
    name: 'EaBookingSheet',
    meta: { title: 'Export Air Booking Sheet', authRequired: true },
    component: () => import('../views/reports/ea/booking-sheet.vue'),
  },
  {
    path: '/reports/airline-statistical',
    name: 'AirlineStatistical',
    meta: { title: 'Airline Statistical Report', authRequired: true },
    component: () => import('../views/reports/ea/airline-statistical.vue'),
  },
  {
    path: '/reports/ea-mawb-monthly-tonnage',
    name: 'EaMawbMonthlyTonnage',
    meta: { title: 'EA MAWB Monthly Tonnage Report per A/L Dest', authRequired: true },
    component: () => import('../views/reports/ea/mawb-monthly-tonnage.vue'),
  },
  {
    path: '/reports/daily-shipment-transmittal',
    name: 'DailyShipmentTransmittal',
    meta: { title: 'Daily Shipment Transmittal', authRequired: true },
    component: () => import('../views/reports/ea/daily-shipment-transmittal.vue'),
  },
  {
    path: '/reports/hawb-inventory',
    name: 'HawbInventory',
    meta: { title: 'HAWB Inventory', authRequired: true },
    component: () => import('../views/reports/ea/hawb-inventory.vue'),
  },
  {
    path: '/reports/ea-transaction-report',
    name: 'EaTransactionReport',
    meta: { title: 'EA Transaction Report', authRequired: true },
    component: () => import('../views/reports/ea/ea-transaction-report.vue'),
  },
  {
    path: '/reports/ea-monthly-production-per-shipper',
    name: 'EaMonthlyProductionPerShipper',
    meta: { title: 'EA Monthly Production per Shipper (Tonnage)', authRequired: true },
    component: () => import('../views/reports/ea/monthly-production-per-shipper.vue'),
  },
  {
    path: '/reports/ea-production-per-country',
    name: 'EaProductionPerCountry',
    meta: { title: 'EA Production per Country', authRequired: true },
    component: () => import('../views/reports/ea/production-per-country.vue'),
  },
  {
    path: '/reports/cab-report',
    name: 'CabReport',
    meta: { title: 'CAB Report', authRequired: true },
    component: () => import('../views/reports/ea/cab-report.vue'),
  },
  {
    path: '/reports/ea-production-per-area',
    name: 'EaProductionPerArea',
    meta: { title: 'EA Production per Area', authRequired: true },
    component: () => import('../views/reports/ea/production-per-area.vue'),
  },
  {
    path: '/reports/hawb-inventory-fin',
    name: 'HawbInventoryFin',
    meta: { title: 'EA HAWB Inventory Report (Fin)', authRequired: true },
    component: () => import('../views/reports/ea/hawb-inventory-fin.vue'),
  },
  {
    path: '/reports/unused-hawb-report',
    name: 'UnusedHawbReport',
    meta: { title: 'EA Unused HAWB Report', authRequired: true },
    component: () => import('../views/reports/ea/unused-hawb-report.vue'),
  },
  {
    path: '/reports/transaction-monitoring',
    name: 'TransactionMonitoring',
    meta: { title: 'Transaction Monitoring Report', authRequired: true },
    component: () => import('../views/reports/ea/transaction-monitoring.vue'),
  },
  {
    path: '/reports/pcv-summary-report',
    name: 'PcvSummaryReport',
    meta: { title: 'PCV Summary Report', authRequired: true },
    component: () => import('../views/reports/ea/pcv-summary-report.vue'),
  },

  // ── Import Air (IA) Reports ─────────────────────────────────────────────
  {
    path: '/reports/ia-cab-report',
    name: 'IaCabReport',
    meta: { title: 'IA CAB Report', authRequired: true },
    component: () => import('../views/reports/ia/cab-report.vue'),
  },
  {
    path: '/reports/ia-top-consignee',
    name: 'IaTopConsignee',
    meta: { title: 'IA Top Consignee', authRequired: true },
    component: () => import('../views/reports/ia/top-consignee.vue'),
  },
  {
    path: '/reports/ia-monthly-production-consignee',
    name: 'IaMonthlyProductionConsignee',
    meta: { title: 'IA Monthly Production per Consignee (Tonnage)', authRequired: true },
    component: () => import('../views/reports/ia/monthly-production-consignee.vue'),
  },
];
